webpackJsonp([84887730282209],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/faq.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"frontmatter": {
					"title": "FAQ",
					"banner": {
						"imageUrl": "/images/faq/faqbanner.jpg",
						"type": "small",
						"anchor": "center"
					}
				}
			}
		},
		"pathContext": {
			"path": "/faq"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---faq-3aff8d0f8b45db88d8d5.js